// extracted by mini-css-extract-plugin
export var blockedMessage = "_98-3";
export var blockedOverlay = "_98-1";
export var fadeIn = "_98-2";
export var hereLink = "_98-0";
export var slideUp = "_98-4";